import { render, staticRenderFns } from "./RegimenGridSetEdit.vue?vue&type=template&id=ed1e5fd6"
import script from "./RegimenGridSetEdit.vue?vue&type=script&lang=js"
export * from "./RegimenGridSetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports